import { Banner, OpacitySlide, PopUp, ReservationCircleButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useGetDMaxCommon, type PopUpResponse } from "@/shared/server";
import { createDate } from "@/utils";
import { Box, Center } from "@chakra-ui/react";
import dayjs from "dayjs";
import { type TopSectionProps } from "./topSection.type";

export const TopSection = ({ imgList, sector }: TopSectionProps) => {
    const { data: popUpData } = useGetDMaxCommon<PopUpResponse>({ section: "popup" });
    const { MEDIAS } = useDesignMaxTheme();
    const { isTablet, isMobile } = MEDIAS();
    return (
        <Box position="relative" h="100dvh">
            {popUpData && (
                <Center
                    position="absolute"
                    top={isMobile ? "108px" : "144px"}
                    left={isTablet ? "24px" : "auto"}
                    right={isTablet ? "auto" : "80px"}
                    zIndex="9999"
                    gap={isMobile ? "36px" : "24px"}
                    flexDir={isTablet ? "column" : "row"}
                >
                    {popUpData.currentPopups.map((currentPopUp) => {
                        const {
                            fromTo: { endDate },
                        } = currentPopUp;
                        const { currentObj } = createDate();
                        const isExpired = currentObj.valueOf() < dayjs(endDate).valueOf();

                        return isExpired && <PopUp key={currentPopUp.postIdx} currentPopUp={currentPopUp} />;
                    })}
                </Center>
            )}
            <OpacitySlide imgList={imgList}>
                <Banner imgList={imgList} sector={sector} />
                <Center
                    w="120px"
                    h="120px"
                    position={isMobile ? "relative" : "absolute"}
                    right={isMobile ? "none" : "100px"}
                    bottom="0px"
                >
                    <ReservationCircleButton />
                </Center>
            </OpacitySlide>
        </Box>
    );
};
